import axios from 'axios';

axios.defaults.baseURL = `${process.env.VUE_APP_API_ENDPOINT}/voucherportal/`;

export default {
    setup() {
        console.log("ajax::setup");
        return axios.post(
            'setup'
        )
    },
    validateCode(code, captchaToken) {
        console.log("ajax::validateCode");
        return axios.post(
            'validate',
            {
                "voucherCode": code.trim(),
                "captchaToken": captchaToken
            }
        )
    },
    activateVoucher(code, ticket, activationCode) {
        console.log("ajax::activateVoucher");
        return axios.post(
            'activate-voucher',
            {
                "voucherCode": code.trim(),
                "ticket": ticket || "",
                "activationCode": activationCode.trim()
            }
        );
    },
    fetchBookingDetails(code, ticket, lang) {
        console.log("ajax::fetchBookingDetails");
        return axios.post(
            'booking-details',
            {
                "voucherCode": code.trim(),
                "ticket": ticket || "",
                "language": lang
            }
        );
    },
    fetchBookingDetailsForToken(token) {
        console.log("ajax::fetchBookingDetailsForToken");
        return axios.post(
            'booking-details/' + token,
            null
        );
    },
    fetchBookingAlternativesForToken(token) {
        console.log("ajax::fetchBookingAlternativesForToken");
        return axios.post(
            'booking-alternatives/view/' + token,
            null
        );
    },
    declineBookingAlternativesForToken(token) {
        console.log("ajax::declineBookingAlternativesForToken", token);
        return axios.post(
            'booking-alternatives/decline/' + token,
            null
        );
    },
    pickBookingAlternativeWithToken(payload) {
        console.log("ajax::pickBookingAlternativeWithToken", payload);
        return axios.post(
            'booking-alternatives/pick/' + payload.token,
            payload
        );
    },
    sendContactForm(requestData, lang) {
        console.log("ajax::sendContactForm");
        return axios.post(
            'contact-request',
            requestData,
            {
                params: { lang }
            }
        )
    },
    savePersonalData(requestData, lang) {
        console.log("ajax::savePersonalData");
        return axios.post(
            'store-personal-data',
            requestData,
            {
                params: { lang }
            }
        )
    },
    finishOrderProcess(requestData, lang) {
        console.log("ajax::finishOrderProcess");
        return axios.post(
            'finalize-order',
            requestData,
            {
                params: { lang }
            }
        )
    },
    sendVoucherDataRequest(requestData) {
        console.log("ajax::sendVoucherDataRequest");
        return axios.post(
            'send-voucher-data',
            requestData
        )
    },
    sendStartExternalBooking(code, ticket, lang) {
        console.log("ajax::sendStartExternalBooking");
        return axios.post(
            'start-external-booking',
            {
                "voucherCode": code,
                "ticket": ticket || "",
                "language": lang
            }
        )
    },
    sendBookingRequest(requestData) {
        console.log("ajax::sendBookingRequest");
        let url = 'booking-request';
        if (requestData.token !== null) {
            url += '/' + requestData.token;
        }
        return axios.post(
            url,
            requestData
        )
    }
};
